import { Theme, createStyles } from '@material-ui/core';
const styles = (theme: Theme) => createStyles({
    root: {
        minWidth: 275,
    },
    historyCTA: {
        marginRight: '10px',
        '& img': {
            marginRight: '10px'
          }
    },
    clickable: {
        cursor: 'pointer'
    },
    notificationBar: {
        border: "solid 1px #1d7dea",
        padding:10,
        position: "relative",
        marginTop:-10,
        borderRadius:2,
        marginBottom:10,
        color: '#1d7dea',
        fontSize: 14,
        lineHeight: '24px',
        display: "flex",
        justifyContent: "space-between",
        '& .icon': {
            padding: '12px 8px 12px 4px',
            '& svg': {
                marginTop: '-3px',
                fill: '#1d7dea'
            }
        },
        '& .closeIcon': {
            padding: '12px 8px 12px 4px',
            cursor: 'pointer',
            '& svg': {
                marginTop: '-3px',
                fill: '#1d7dea'
            }
        }
    },
    verticleLine: {
        border: '0.5px solid #333333',
        margin: '0 12px',
        backgroundColor: '#333'
      },
    expansionRoot: {
        flex: 'grow'
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    tabContainer: {
        padding: "12px 0",
        borderBottom: "0.5px solid #bcbcbc",
        paddingBottom: 6,
        margin: "0px 12px",
        height: '73px'
    }, 
    tabPanel: {
        marginTop: 25,
        marginBottom: 12, 
        // background: 'rgb(255 255 0)',
        position: 'absolute',
        right: 0,
        left: 0,
        top: '100%',
        width: "calc(100vw - 130px)",        
        '& .subPanel': {
          color: 'rgb(153 153 153)',
          padding: "0",
          fontSize:16,
          fontWeight:600,
          cursor: 'pointer',
          '& > *': {
            cursor: 'pointer',
          }
        }, 
        '& > *': {
            marginBottom: 10,
          } , 
        '& .activeTab':{
          color: '#1D7DEA'
        }, 
      },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    link: {
        fontSize: '1.125rem',
        '&:hover': {
            color: '#333',
            fontWeight: 600
        }
    },
    primaryBtn: {
        background: '#1D7DEA',
        borderRadius: 4,
        maxWidth: 186,
        minHeight: 44
    },
    fontWeight600: {
        fontWeight: 600
    },
    blackColor: {
        color: '#333'
    },
    darkGrey: {
        color: '#999'
    },
    dialogTitle: {
        fontWeight: 600,
        fontSize: 24,
        color: '#333'
    },
    labelText: {
        '& :nth-child(2)': {
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: 16,
            lineHeight: '19px',
            color: '#333333',
            marginTop: 2
        }
    },
    HeadingText: {
        fontSize: 18,
        color: '#333',
        marginBottom: 10,
    },
    paddingLeft56: {
        paddingLeft: 56
    },
    linearProgressStyle: {
        minWidth: '85px',
        margin: '0 5px',
        display: 'flex',
        alignItems: "center",
        "&>div:nth-of-type(1)": {
          display: "flex",
          minWidth: '85px',
          margin: '0 5px',
          borderRadius: 4,        
        },
      },
});

export { styles };